<script lang="ts">
import { defineComponent, reactive } from 'vue'
import stateInitializer from '@/models/stateInitializer'

export default defineComponent({
  name: 'OptoutMain',

  setup() {
    interface State {
      optoutProviders: Array<{ name: string, url: string }>,
    }
    const state: State = reactive({
      optoutProviders: [],
    })
    stateInitializer(state, 'main')

    return {
      // data
      state,
    }
  }
})
</script>

<template>
  <article class="article">
    <section class="section">
      <p class="p">
        当社は、お客様の興味・関心に沿った広告を配信するために、お客様の行動履歴情報（アクセスしたURL、コンテンツ、参照順等）及び属性情報（年齢、性別、職業、居住地域等であって個人が特定できない範囲の情報）を、広告配信サービスを提供する事業者（以下、「広告配信事業者」といいます）に提供したうえで、当該広告配信事業者が提供する行動ターゲティング広告サービスを利用しております。
      </p>

      <p class="p">
        この行動ターゲティング広告の配信停止及び行動履歴情報等の提供停止（オプトアウト）をしたい場合は、次に掲げる各広告配信事業者のオプトアウト設定にかかるページへアクセスし、所定の手順に従って設定をしてください。
      </p>

      <p class="p">
        なお、当該設定をされた後、実際に当該設定がシステム上反映されるまで、時間がかかる場合があります。当該設定がシステム上反映された後は、行動ターゲティングによらない広告が表示されます。
      </p>
    </section>

    <section class="section">
      <h2 class="h2">
        行動ターゲティング広告の配信停止及び行動履歴情報等の提供停止（オプトアウト）
      </h2>

      <p class="p">
        以下の広告配信事業者のオプトアウト設定にかかるページで、行動ターゲティング広告の配信停止手続等を行ってください。
      </p>

      <table class="table">
        <colgroup class="colgroup">
          <col class="col">
          <col class="col">
        </colgroup>

        <thead class="thead">
          <tr class="tr">
            <th class="th">
              事業者名
            </th>
            <th class="th">
              URL
            </th>
          </tr>
        </thead>

        <tbody class="tbody">
          <tr
            v-for="optoutProvider in state.optoutProviders"
            :key="optoutProvider.name"
            class="tr">
            <th class="th u-text__nowrap">
              {{ optoutProvider.name }}
            </th>
            <td class="td">
              <a
                class="a"
                :href="optoutProvider.url"
                target="_blank">
                {{ optoutProvider.url }}
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </article>
</template>
